import { useQuery } from '../lib/useQuery'
import { GetUnstableData } from '../graphql/docs'
import Segment from '../components/Segment'
import { Logger } from '@wolfdanepug/common-react'

export default function Dog({ params = {} }: any) {
	const { data: onboardingData = {}, loading } = useQuery(GetUnstableData, {
		context: 'onboarding'
	})

	Logger.log('[Get Started] dogs dog', params, onboardingData)
	if (loading) return null
	return <Segment name="dog-info" data={onboardingData?.data} />
}
